import {
    initAccordion,
    slideToggle,
} from '@js/common/customFunctions.js';

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    initAccordion('.bgan-resource-section .brs-tags-list');
    initAccordion('.resource-details-hero-section .rtdhs-tags-list');
    initAccordion('.product-body-section .pbs-tags-list');
    initBganResourceDropdown();
});

const initBganResourceDropdown = () => {
    const sections = document.querySelectorAll('.bgan-resource-section');

    if (!sections.length) {return;}

    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const setupDropdown = () => {
        sections.forEach(section => {
            const title = section.querySelector('.brs-post-dropdown-title');
            const content = title ?.nextElementSibling;

            if (!title || !content) {return;}

            // Remove previous listeners by cloning (safe re-init)
            const newTitle = title.cloneNode(true);
            title.parentNode.replaceChild(newTitle, title);

            if (mediaQuery.matches) {
                newTitle.addEventListener('click', () => {
                    newTitle.classList.toggle('is-active');
                    slideToggle(content);
                });
            } else {
                // Desktop reset
                newTitle.classList.remove('is-active');
                content.style.display = '';
            }
        });
    };

    setupDropdown();
    mediaQuery.addEventListener('change', setupDropdown);
};